module.exports = __webpack_public_path__ + "files/9733cf0eb2e8cfcf4f07017f774eda4a.png";